import { BsDatepickerConfig, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';

export function getDatePickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDatepickerConfig(), {
    containerClass: 'theme-red',
    showWeekNumbers: false
  } as BsDatepickerConfig);
}

export function getDateRangePickerConfig(): BsDatepickerConfig {
  return Object.assign(new BsDaterangepickerConfig(), {
    containerClass: 'theme-red',
    showWeekNumbers: false
  } as BsDatepickerConfig);
}